export enum Confirm {
  Confirm = "완료되었습니다.",
  Error = "입력 사항을 다시 확인해주세요.",
  Init = "",
  Delete = "삭제가 완료되었습니다.",
  Update = "수정이 완료되었습니다.",
  PostNotification = "메시지를 전송하였습니다.",
}
